<template>
  <div class="account-location">
    <el-page-header @back="$router.go(-1)" content="账号运营"> </el-page-header>

    <el-tabs v-model="activeName" type="card" style="margin-top: 20px">
      <el-tab-pane label="团队账号" name="1">
        <MyAccount ref="MyAccount" />
      </el-tab-pane>
      <el-tab-pane label="成果展示" name="2">
        <Result ref="Result" />
      </el-tab-pane>
      <el-tab-pane label="英雄榜" name="3" lazy>
        <Ranking category="yy" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MyAccount from "./myAccount.vue";
import Ranking from "../ranking.vue";
import Result from "./result.vue";
export default {
  components: { Ranking, Result, MyAccount },
  data() {
    return {
      activeName: "1",
    };
  },
  watch: {
    activeName(val) {
      if (val == "1") this.$refs.MyAccount.getList();
      else if (val == "2") this.$refs.Result.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.account-location {
  padding: 20px 33px;
  background-color: #ffffff;
}
</style>